var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2283 0H1.77165C0.794793 0 0 0.786773 0 1.75378V14.2462C0 15.2134 0.794793 16 1.77165 16H18.2283C19.2054 16 20 15.2132 20 14.2462V1.75378C20 0.786773 19.2052 0 18.2283 0ZM6.95436 3.22848C7.73442 3.22848 8.36924 3.8569 8.36924 4.62909C8.36924 5.40128 7.73442 6.0297 6.95436 6.0297C6.1743 6.0297 5.53947 5.40128 5.53947 4.62909C5.53947 3.8569 6.1743 3.22848 6.95436 3.22848ZM1.77165 14.8133C1.45579 14.8133 1.19901 14.5591 1.19901 14.2464V12.584L4.21115 8.70881C4.27932 8.62115 4.3845 8.56994 4.49635 8.56994C4.60803 8.56994 4.71338 8.62115 4.78155 8.70881L7.36207 12.0285L7.13494 12.3205L6.90815 12.6125L5.1971 14.8133L1.77165 14.8133ZM18.801 14.2464C18.801 14.5591 18.5443 14.8133 18.2284 14.8133H6.10545L7.36221 13.1965L7.589 12.9045L7.81613 12.6125L7.8247 12.6237L13.6358 5.14837C13.704 5.06071 13.8091 5.0095 13.921 5.0095C14.0327 5.0095 14.138 5.06071 14.2062 5.14837L18.8013 11.0593L18.801 14.2464Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.9fbf24aae4cdb3a7c5f6e1b42e85018a.svg";
export { ForwardRef as ReactComponent };